import { MY_ACCOUNT_VIEW_QUERY_PARAM } from './myAccountDeepLinksFlow';
import { isDeviceNative } from '../../utils/deviceDetection';

export function myAccountNativeDeepLinksFlow(cfg) {
  if (typeof window === 'undefined' || !cfg || !cfg.enabled || !isDeviceNative()) {
    return;
  }
  const myAccountView = new URLSearchParams(window.location.search).get(MY_ACCOUNT_VIEW_QUERY_PARAM);
  if (!myAccountView) {
    return;
  }
  const standaloneUrl = cfg.mapping[myAccountView];
  if (!standaloneUrl) {
    return;
  }

  setTimeout(() => {
    window.location.href = `whsbkh://?action=openURLWithLogin&url=${encodeURIComponent(standaloneUrl)}`;
  }, 0);
}
